import type { Dispatch } from 'redux';
import { createActionFactory, Feature, ThunkDispatch } from '../../../shared';
import { importContactsUploadFile } from '../data/importContactsDialogDataActions';

export const importContactsLoadFileClickedAction = createActionFactory(
    'ImportContactsLoadFileClickedAction',
    Feature.ImportContacts
);

export const importContactsUploadFileClickedAction = createActionFactory(
    'ImportContactsUploadFileClickedAction',
    Feature.ImportContacts
);

export const importContactsDismissedClickedAction = createActionFactory(
    'ImportContactsDismissedClickedAction',
    Feature.ImportContacts
);

export const importContactsLoadFileClicked = (dispatch: Dispatch) => () =>
    dispatch(importContactsLoadFileClickedAction());

export const importContactsUploadFileClicked = (dispatch: ThunkDispatch) => () => {
    dispatch(importContactsUploadFileClickedAction());
    dispatch(importContactsUploadFile());
};

export const importContactsDismissedClicked = (dispatch: Dispatch) => () =>
    dispatch(importContactsDismissedClickedAction());
export type { DataActionFactory } from '../../../shared';
export type { Action } from '../../../shared';
